import type { FaireProductEntity } from "../../entity_types/product";

export const p_hu6e4zphx2: FaireProductEntity = {
  token: "p_hu6e4zphx2",
  type: "product",
  name: "Tuberose Musk– HI-FI Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/4c7ea3d0c6c5e95312ba34195e033710000ae9507796f616bd4fec0b680446f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/353472cdd5bcf652c3c8c2c507d41785657d136c3b554f9e0eba5dc4c0bf0ad1.jpeg",
    "https://cdn.faire.com/fastly/97e1ac7e4a8848478941e4581328beae5edf902f7b52173ea5e89dd59417f62f.jpeg",
    "https://cdn.faire.com/fastly/1800cee1b16136e06841986db86e83ff461a99b2a2da537025a479230571633c.jpeg",
    "https://cdn.faire.com/fastly/1efbdbab20d56c469535ae300b7de2a9a090507e89c8967eb1bc4707d5a8be5e.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "An opulent green floral. Escapes to warmer climates, gardens draped in morning dew, light streaming through sheer curtains. \n\nTuberose Musk is an opulent green floral, for post-clean resets, instant grounding, and escapes to warmer climates. This scent feels both familiar and dreamy, evocative of ornate vases bursting with white florals, gardens draped in morning dew, and light streaming through sheer curtains. \n\nTop notes of fresh cut stems, orange blossom, and ozone are blended with blooming tuberose, jasmine sambac, and ylang ylang, balanced by cashmere wood, sheer sandalwood, and translucent musk.\n\nPRODUCT INFORMATION: \n\nOur 13 oz Double Wick Hi-Fi Candles are hand-poured into premium cocoa brown vessels with a vermilion debossed label, and packaged in a premium paper gift box.\n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for up to 60 hours.",
  tags: [],
  msrpDollars: 43.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:51.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
